import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import {
  faCog,
  faHomeAlt,
  faIndustry,
  faTicket,
  faTools,
} from '@fortawesome/pro-regular-svg-icons';
import i18next from 'i18next';
import { routes } from 'src/routes';
import { Role } from 'src/store/models/Auth';
import { faCustomIcon } from 'src/utils/iconUtils';

import { furnaceIcon } from './iconConstants';

export interface SidebarItems {
  [Role.ADMIN]: SidebarItem[];
  [Role.MANUFACTURER]: SidebarItem[];
  [Role.SERVICE]: SidebarItem[];
}

export interface SidebarItem {
  icon?: IconDefinition;
  label: string;
  pathname: string;
  subitems?: SidebarItem[];
}

export const sidebarItems: SidebarItems = {
  [Role.ADMIN]: [
    {
      icon: faHomeAlt,
      label: i18next.t('common:dashboard'),
      pathname: routes.HOME,
    },
    {
      icon: faIndustry,
      label: i18next.t('common:manufacturer_accounts'),
      pathname: routes.MANUFACTURER_ACCOUNTS,
    },
    {
      icon: faCog,
      label: i18next.t('common:settings'),
      pathname: routes.SETTINGS,
    },
  ],
  [Role.MANUFACTURER]: [
    {
      icon: faHomeAlt,
      label: i18next.t('common:dashboard'),
      pathname: routes.HOME,
    },
    {
      icon: faTools,
      label: i18next.t('common:service_accounts'),
      pathname: routes.SERVICE_ACCOUNTS,
      subitems: [
        {
          label: i18next.t('common:companies'),
          pathname: routes.COMPANIES,
        },
        {
          label: i18next.t('common:personnel'),
          pathname: routes.SERVICE_ACCOUNTS,
        },
        {
          label: i18next.t('service_account:auto_assign'),
          pathname: routes.AUTO_ASSIGN,
        },
      ],
    },
    {
      icon: faTicket,
      label: i18next.t('common:tickets'),
      pathname: routes.TICKETS,
    },
    {
      icon: faCustomIcon('furnace', 20, 17, furnaceIcon),
      label: i18next.t('common:products'),
      pathname: routes.PRODUCTS,
    },
    {
      icon: faCog,
      label: i18next.t('common:settings'),
      pathname: routes.SETTINGS,
    },
  ],
  [Role.SERVICE]: [
    {
      icon: faHomeAlt,
      label: i18next.t('common:dashboard'),
      pathname: routes.HOME,
    },
    {
      icon: faTicket,
      label: i18next.t('common:tickets'),
      pathname: routes.TICKETS,
    },
    {
      icon: faCustomIcon('furnace', 20, 17, furnaceIcon),
      label: i18next.t('common:products'),
      pathname: routes.PRODUCTS,
    },
    {
      icon: faCog,
      label: i18next.t('common:settings'),
      pathname: routes.SETTINGS,
    },
  ],
};
